import { render, staticRenderFns } from "./import-contacts-box.vue?vue&type=template&id=a8a1138a&scoped=true"
import script from "./import-contacts-box.vue?vue&type=script&lang=js"
export * from "./import-contacts-box.vue?vue&type=script&lang=js"
import style0 from "./import-contacts-box.vue?vue&type=style&index=0&id=a8a1138a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a1138a",
  null
  
)

export default component.exports